// 7.1.13 ToObject(argument)
var defined = require('./$.defined');
module.exports = function(it){
  return Object(defined(it));
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/$.to-object.js
 ** module id = 19
 ** module chunks = 0
 **/